/**
 * Hook para polling de estados de entregas cada 30 segundos
 * @returns {{ deliveries: Array, loading: boolean, error: string|null }}
 */

import { useState, useEffect, useContext, useRef } from 'react';
import { StateContext } from '../../../components/context/StateProvider';
import EntregasService from '../api/entregas.api';
import { POLLING_INTERVAL } from '../constants';

export const useEstadoEntregas = () => {
    const { state } = useContext(StateContext);
    const [deliveries, setDeliveries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const isFirstLoad = useRef(true);

    useEffect(() => {
        /**
         * Función para obtener los estados de entregas desde la API
         * Solo muestra loading en la primera carga, no en los refreshes automáticos
         */
        const fetchDeliveries = async () => {
            try {
                // Solo mostrar loading en la primera carga
                if (isFirstLoad.current) {
                    setLoading(true);
                }
                setError(null);
                const data = await EntregasService.getEstados(state.year);
                setDeliveries(data);

                // Marcar que ya no es la primera carga
                if (isFirstLoad.current) {
                    isFirstLoad.current = false;
                }
            } catch (err) {
                console.error('Error al cargar estados de entregas:', err);
                setError(err.message || 'Error al cargar estados de entregas');
                setDeliveries([]);
            } finally {
                // Solo quitar loading si estaba activo
                if (loading) {
                    setLoading(false);
                }
            }
        };

        // Fetch inicial al montar
        fetchDeliveries();

        // Configurar polling cada 30 segundos (actualiza en background)
        const intervalDeliveries = setInterval(fetchDeliveries, POLLING_INTERVAL);

        // Cleanup: limpiar interval al desmontar
        return () => {
            clearInterval(intervalDeliveries);
        };
    }, [state.year]); // Re-fetch si cambia el año en el contexto

    return {
        deliveries,
        loading,
        error
    };
};
